import { PersonaPresence } from "@fluentui/react/lib/Persona";
import {
    CampoVersioneEF_Status, ProtocolloAreaDiLavoroEF_Priority, ProtocolloAreaDiLavoroEF_State,
    Visibility_Type, SearchSortDirection
} from "./enums";
import { IField, IProtocol, IVisibilita } from "./interfaces";

export interface ICampoDTO {
    internalName: string
    internalValue: object
}


export interface ICampoVersioneDTO extends ICampoDTO {
    status: CampoVersioneEF_Status
}


export interface IVisibilitaDTO {
    entityId: number;
    accessType: Visibility_Type;
}

export interface IUserInfoDTO{
    objectIdentifier: string;
    userPrincipalName: string;
    displayName: string;
    defaultAooId?: number;
    isSuperAdmin: boolean;

    initials: string;
    imageUrl: string;
    //presence: PersonaPresence;

    ruoliAooContext: IRuoloAooDTO[];
    ruoliUorContext: IRuoloUorDTO[];
}


export interface IRuoloAooDTO {
    aooId: number;
    userId: string;
    ruoloId: number;
    ruoloNome: string;
}
export interface IRuoloUorDTO {
    aooId: number;
    uorId: number;
    userId: string;
    ruoloId: number;
    ruoloNome: string;
}

export interface IProtocolloAreaDiLavoro extends IProtocol {
    areaDiLavoroId: number;
    uorId: number;
    presaInCarico: string;
    statoLavorazione: ProtocolloAreaDiLavoroEF_State;
    priorita: ProtocolloAreaDiLavoroEF_Priority;

}


export interface ISearchFilter {
    internalName: string;
    value: any;
}

export interface ISearchSort {
    fieldName: string;
    direction: SearchSortDirection;
}

export interface ISearchCriteria {
    pageNumber: number;
    pageSize?: number;
    globalSearch?: string;
    filters: ISearchFilter[];
    sorts: ISearchSort[];
}
export interface ISearchPageResult<T> {
    items: T[];
    totalCount?: number | null;
}

// --- Write DTO: contratto esatto con il backend ProtocolSP ---

export interface IFileSavePayload {
    id?: number;
    fileName: string;
}

export interface IFieldSavePayload {
    internalName: string;
    internalValue: any;
}

export interface IVisibilitaSavePayload {
    uor: { id: number, aooId?: number; };
    tipologia: IVisibilita['tipologia'];
}

export interface IProtocolSavePayload {
    tipoProtocollo?: IProtocol['tipoProtocollo'];
    statoProtocollo?: IProtocol['statoProtocollo'];
    titolario?: string;
    documentFile?: IFileSavePayload;
    attachments?: IFileSavePayload[];
    fields?: IFieldSavePayload[];
    visibilita?: IVisibilitaSavePayload[];
}

export const SearchFilterNames = {
    UorId: 'UorId',
    VisibilitaTipo: 'VisibilitaTipo',
    Priorita: 'Priorita',
    PresaInCarico: 'PresaInCarico'
} as const;


export interface IWorkspaceSearchPageResult extends ISearchPageResult<IProtocolloAreaDiLavoro> { }
export interface IProtocolsSearchPageResult extends ISearchPageResult<IProtocol> { }


